import { INotificationData } from "./notificationSliceInterfaces";


// A mock function to mimic making an async request for data
export function fetchNotification(notification: INotificationData) {
	return new Promise<{ data: INotificationData }>((resolve) => setTimeout(() => resolve({ data: notification }), 500));
}
